<template>
  <div class="admin container">
    <div class="row">
      <h1>Login Ludo Map</h1>
    </div>
    <div class="row">
      <div class="form-group">
        <input type="text" name="username" v-model="input.username" placeholder="Gebruikersnaam" />
        <button type="submit" class="btn btn-sm btn-primary mb-2" v-on:click="addUser()">Sla op</button>
      </div>
    </div>
    <div class="row">
      <table class="table">
        <tr>
          <th class="scope">Gebruikersnaam</th>
          <th class="scope">Code</th>
          <th class="scope">&nbsp;</th>
        </tr>
        <tr v-for="user in userList">
          <td>{{user.username}}</td>
          <td><b>{{user.code}}</b></td>
          <td><button type="button" class="btn btn-sm btn-primary mb-2" v-on:click="deleteUser(user._id)">Verwijder</button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'admin',
  data() {
    return {
      input: {
        username: "",
        password: ""
      },
      error: false,
      userList: []
    }
  },
  methods: {
    addUser() {
      if(this.input.username) {
        this.$http.post("https://server.ludodidactiek.soft-ice.nl/users/create", this.input, { headers: { "content-type": "application/json" } }).then((result) => {
          // this.userList = result;
          this.userList = result.data;
          this.input.username = "";
        }, () => {
          this.error = "Het e-mailadres of de code is niet goed";
        })
      }
    },
    deleteUser(id) {
        this.$http.post("https://server.ludodidactiek.soft-ice.nl/users/delete",{id: id}, { headers: { "content-type": "application/json" } }).then((result) => {
          // this.userList = result;
          this.userList = result.data;
          this.input.username = "";
        })
    }
  },
  mounted() {
    this.$http.get("https://server.ludodidactiek.soft-ice.nl/users/list", { headers: { "content-type": "application/json" } }).then((result) => {
      this.userList = result.data;
    }, () => {
      this.error = "Het e-mailadres of de code is niet goed";
    })
  }
}
</script>

<style>
  td, th{
    text-align: left;
  }
</style>
